import type { AnalyticsCachedSettings } from 'owa-analytics-types';
import type { AccountKey } from 'owa-client-types';

const analyticsCachedSettingsByAccountKey = new Map<
    AccountKey | 'globalAccount',
    AnalyticsCachedSettings
>();

export function getCachedSettings(
    accountKey: AccountKey | 'globalAccount'
): AnalyticsCachedSettings | null {
    return analyticsCachedSettingsByAccountKey.get(accountKey) ?? null;
}

export function setCachedSettings(
    accountKey: AccountKey | 'globalAccount',
    settings: AnalyticsCachedSettings
): void {
    analyticsCachedSettingsByAccountKey.set(accountKey, settings);
}

export function updatePartialCachedSettings(
    accountKey: AccountKey | 'globalAccount',
    partialSettings: Partial<AnalyticsCachedSettings>
): void {
    analyticsCachedSettingsByAccountKey.set(accountKey, {
        ...analyticsCachedSettingsByAccountKey.get(accountKey),
        ...partialSettings,
    } as AnalyticsCachedSettings);
}
